export enum FormFieldStatus {
    /**
     * @description Invalid status
     */
    Invalid = 'invalid',

    /**
     * @description Valid status
     */
    Valid = 'valid',

    /**
     * @description Both status
     */
    Both = 'both',
}

/**
 * @description Form field status type
 * @example
 * const formFieldStatus: FormFieldStatusType = 'invalid' | 'valid' | 'both'
 */
export type FormFieldStatusType = 'invalid' | 'valid' | 'both';

/**
 * @description Form field status type
 * @example
 * const formFieldStatus: IFormFieldStatus = 'invalid' | 'valid' | 'both'
 * const formFieldStatus: IFormFieldStatus = FormFieldStatus.Invalid
 * const formFieldStatus: IFormFieldStatus = FormFieldStatus.Valid
 * const formFieldStatus: IFormFieldStatus = FormFieldStatus.Both
 */
export type IFormFieldStatus = FormFieldStatusType | FormFieldStatus;